import format from 'date-fns/format';
import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useGetInvoicesQuery } from '../../../api/invoiceApiSlice';
import Block from '../../../components/Block';
import { Icon, Loader } from '../../../components/components';
import Table from '../../../components/tables/Table';
import Pagination from "../../../components/tables/Pagination";
import useCustomTable from '../../../components/tables/useCustomTable';
import Title from '../../../components/Title';

const Financials = (props) => {
  const {t} = useTranslation()
  const location = useLocation();
  const history = useHistory();
  const { data: invoices=[], isSuccess, isLoading } = useGetInvoicesQuery()
  const invoicesTable = useMemo(() => {
    return invoices.map((d)=>({
      ...d,
      gross: d.data_vendor_amount - d.publisher_amount,
      date: format(new Date(d.year, d.month-1, 1), 'yyyy-MM-dd')
    }))
  }, [invoices])
  const onRowClick = (row) => history.push(`${location.pathname}/${row.year}/${row.month}`)

  const {
    tableProps,
    paginationProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {date: 'desc'},
  })
  const columns = [{
    Header: 'Date',
    Cell: ({row}) => (format(new Date(row.original.year, (row.original.month-1), 1), 'MMMM yyyy')),
    accessor: 'date',
    // sortType: 'datetime',
    format: 'date'
  },{
    Header: t('invoices.mrg'),
    accessor: 'mrg',
    format: 'price'
  },{
    Header: t('invoices.rev_share_amount'),
    accessor: 'rev_share_amount',
    format: 'price'
  },{
    Header: t('invoices.publisher_amount'),
    accessor: 'publisher_amount',
    format: 'price'
  },{
    Header: t('invoices.data_vendor_amount'),
    accessor: 'data_vendor_amount',
    format: 'price'
  },{
    Header: t('invoices.gross'),
    accessor: 'gross',
    format: 'price'
  }
  ];

  return ( <>
    <Title main={t("invoice")}>
      <Button  href={`/v1/invoices.csv`}>
        <Icon icon='csv' text={t("download")} />
      </Button>
    </Title>
    <Block className="mb-0">
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <Table
          data={invoicesTable}
          columns={columns}
          onRowClick={onRowClick}
          {...tableProps} />
      </Loader>
    </Block>
    <Pagination {...paginationProps}/>
  </> );
}

export default Financials;
